import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCart({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4a1 1 0 010-2h.138A3 3 0 016.13 4.786l.735 10.285a1 1 0 00.997.929h7.784a1 1 0 00.928-.629l2.4-6A1 1 0 0018.046 8H9a1 1 0 110-2h9.046a3 3 0 012.785 4.114l-2.4 6A3 3 0 0115.646 18H7.862a3 3 0 01-2.992-2.786L4.135 4.929A1 1 0 003.138 4H3zm4.5 18a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm8 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCart
